import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from 'client/app/modules/shared/shared.module';
import { FontAwesome } from 'client/app/modules/font-awesome/font-awesome.module';

import { BundlesRoutingModule } from './bundles-routing.module';

import { BundleListComponent } from './bundle-list/bundle-list.component';
import { BundleComponent } from './bundle/bundle.component';
import { BundleFormComponent } from './bundle-form/bundle-form.component';

@NgModule({
	declarations: [BundleListComponent, BundleComponent, BundleFormComponent],
	imports: [
		BundlesRoutingModule,
		CommonModule,
		ReactiveFormsModule,
		NgSelectModule,
		NgbModule,
		SharedModule,
		FontAwesome
	]
})
export class BundlesModule { }
